import { apiClient } from "./client";

export interface DisplayTokenView {
  token: string;
  branchId: string;
  label: string;
  expiresAt: string;
  lastUsedAt: string | null;
  revoked: boolean;
}

export interface IssueRequest {
  branchId: string;
  label: string;
  /** Optional — server defaults to +1 year. ISO-8601 string. */
  expiresAt?: string | null;
}

/**
 * Admin endpoints behind {@code /api/v1/queue/display-tokens} — issue, list,
 * and revoke kiosk-tokens for the waiting-room TV queue display.
 */
export const displayTokensApi = {
  list(): Promise<DisplayTokenView[]> {
    return apiClient
      .get<DisplayTokenView[]>("/v1/queue/display-tokens")
      .then((r) => r.data);
  },
  issue(body: IssueRequest): Promise<DisplayTokenView> {
    return apiClient
      .post<DisplayTokenView>("/v1/queue/display-tokens", body)
      .then((r) => r.data);
  },
  revoke(token: string): Promise<void> {
    return apiClient
      .delete(`/v1/queue/display-tokens/${encodeURIComponent(token)}`)
      .then(() => undefined);
  },
};

/**
 * Build the public kiosk URL the clinic copies onto the TV. The token is
 * embedded as a query param so a single fixed URL is all the device needs.
 */
export function kioskUrlFor(token: string): string {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://addy.vn";
  return `${origin}/display/queue?token=${encodeURIComponent(token)}`;
}
